<template>
<div class="chapter">
<div class="inner_page">
<div class="epigraphPage">
<a id="title36"></a>
<div class="verse"><span><em class="i">No se puede mirar.</em> One cannot look at this.<br/> <em class="i">Yo lo vi</em>. I saw it. <em class="i">Esto es lo verdadero.</em> This is the truth.</span></div>
<div class="p-blanc"><span> <br/></span></div>
<div class="source"><span>—FRANCISCO GOYA</span></div></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9781429923200_epi01.vue?6e932e2b